export default __webpack_public_path__ + "static/media/MenuIcon_Header.512e1e20.svg";